import api from '@/api.js'
import * as OpenCC from 'opencc-js'
const converter = OpenCC.Converter({ from: 'cn', to: 'tw' })
import { mapGetters } from 'vuex'
var All = {
  computed: {
    ...mapGetters([
      'authorized',
      'ai_sid',
      'ai_uuid'
    ]),
    d_point () {
      return localStorage.getItem('RD_p') ? parseInt(localStorage.getItem('RD_p')) : 10
    },
    d_pu () {
      const puMap = { p: '點', t: '次', n: null }
      let puValue = localStorage.getItem('RD_pu')
      if (puValue) {
        return puMap[puValue]
      }

      return '點'
    }
  },
  methods: {
    getTTSUrl (gender, result) {
      let path = `/ai/tts`
      if (this.$route.name === 'ChatAIJp' || this.$route.name === 'SpeechAIJp') {
        path = path + `/?lang=ja-JP`
      } else {
        path = path + `/?lang=${this.$store.state.selectedAccent}`
      }

      return api.post(path, {
        text: result,
        // eslint-disable-next-line
        gender: gender ? gender : 'female',
        kid: false
      })
      .then((res) => {
        return res.data.url
      })
      .catch(() => {
        return ''
      })
    },

    get_Translate_Dialog (theme, context, result) {
      let self = this
      // 會話翻譯

      let path = `/ai/generate/15044d0c-2c65-4e1c-81bd-b57f0983686e`

      if (self.$route.name === 'ChatAIJp') {
        path = `/ai/generate/d4e0a2ad-0a5a-49dc-aaef-11f370b31462`
      }

      return api.post(path, {
        content: result,
        theme: theme,
        context: context
      })
      .then((res) => {
        return converter(res.data.result)
      })
      .catch(() => {
      })
    },
    get_Translate_Speech (result) {
      // let self = this
      // 書信/寫作翻譯

      let path = `/ai/generate/e3714685-1955-4f85-bc73-5652ff3fc80d`

      // const converter = OpenCC.Converter({ from: 'cn', to: 'tw' })

      return api.post(path, {
        content: result
      })
      .then((res) => {
        return converter(res.data.result)
      })
      .catch(() => {
      })
    },
    playAudioStandard (dynamicId) {
      let self = this

      if (self.$refs[`playBtn${dynamicId}`]) {
        let audioPlayer = self.$refs[`playBtn${dynamicId}`]

        audioPlayer.onplaying = () => {
          self.isPlaying = true
        }
        audioPlayer.onpause = () => {
          self.isPlaying = false
        }
        // 播放切換
        if (self.isPlaying) {
          audioPlayer.pause()
          audioPlayer.currentTime = 0
          self.isPlaying = false
        } else {
          audioPlayer.play()
          self.isPlaying = true
        }
      }
    },

    copy_text_selection (text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
        })
        .catch(() => {
        })
    },

    objIsEmpty (obj) {
      if (obj && Object.keys(obj).length === 0) {
        return true
      }
      return false
    },

    isNotEmpty (array) {
      let isNotEmptyFunc = (obj) => {
        return Object.keys(obj).length !== 0
      }

      return array.every(isNotEmptyFunc)
    },

    generateCheck () {
      let self = this
      return self.$swal.fire({
        title: '提醒',
        html: `目前總點數：<span class="gept_main_color9">${100}</span> 點<br/>每次交卷看報告隨即扣除 1 點。`,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: `我知道了`,
        customClass: {
          container: '',
          popup: 'p-0',
          header: 'pt-8 text-sm gept_main_color4',
          title: 'gept_main_color4',
          closeButton: '',
          htmlContainer: 'p-4 font-bold leading-loose',
          actions: 'mb-4 mt-5',
          confirmButton: 'denyButton-gept',
        }
      })
      .then((result) => {
        console.log(result)
          if (result.confirm === true) {
            return true
          }
        }
      )
    },

    checkSubmitReport (pName, pType) {
      let html

      if (localStorage.getItem('RD_pu') && localStorage.getItem('RD_pu') === 'n') {
        html = `<p class="gept_main_color4 text-2xl mb-4">確認完成 ${pName} ${pType} 題型練習?</p>
        <p class="text-left mb-2">按下確認鍵後，請稍待片刻由AI英語小助教立即為您進行AI批改。</p>`
      } if (localStorage.getItem('RD_pu') && localStorage.getItem('RD_pu') !== 'n') {
        html = `<p class="gept_main_color4 text-2xl mb-4">確認完成 ${pName} ${pType} 題型練習?</p>
        <p class="text-left mb-2">按下確認鍵後，請稍待片刻由AI英語小助教立即為您進行AI批改。</p>
        <p class="text-left mb-1">目前總${this.d_pu}數 ${this.$store.state.remainPoints} ${this.d_pu}</p>
        <p class="text-left mb-1">需扣除 ${this.d_point} ${this.d_pu}</p>
        <p class="text-left">扣除後${this.d_pu}數 ${this.$store.state.remainPoints - this.d_point}</p>`
      }  else {
        html = `<p class="gept_main_color4 text-2xl mb-4">確認完成 ${pName} ${pType} 題型練習?</p>
        <p class="text-left mb-2">按下確認鍵後，請稍待片刻由AI英語小助教立即為您進行AI批改。</p>
        <p class="text-left mb-1">目前總點數 ${this.$store.state.remainPoints} 點</p>
        <p class="text-left mb-1">需扣除 10 點</p>
        <p class="text-left">扣除後點數 ${this.$store.state.remainPoints - this.d_point}</p>`
      }
      return this.$swal({
        html: html,
        showDenyButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        denyButtonText: `返回`,
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-4',
          header: 'p-0',
          closeButton: '',
          htmlContainer: 'remainPoints_swal my-4 text-left',
          actions: 'mb-4 mt-2',
          confirmButton: 'submitButton-gept order-2',
          denyButton: 'denyButton-gept order_1'
        }
      })
        .then((result) => {
          if (result.isConfirmed === true) {
            return true
          } else {
            return false
          }
        }
      )
    },

    post_records_by_AIETA (exam_id, id, part, text, file) {
      let path = `/toeic/exams/${exam_id}/records`

      let formData = new FormData()
      formData.append('file', file)
      formData.append('id', id)
      formData.append('part', part)
      formData.append('text', text)

      return api.post(path, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        })
        .then((response) => {
          return response.data
        })
    },

    get_records (exam_id) {
      // let self = this

      let path = `/api/toeic/exams/${exam_id}/records`

      return api.get(path)
      .then((res) => {
        return res
      })
      .catch(() => {
      })
    },

    get_exams_records (exam_id, recordId) {
      // let self = this

      let path = `/toeic/exams/${exam_id}/records/${recordId}`

      return api.get(path)
      .then((res) => {
        return res
      })
      .catch(() => {
      })
    },

    async finish_exams (exam_id, part, isGuideLink) {
      let self = this
      let attempt = 0
      let maxRetries = 10
      let retryInterval  = 10000
      let path = `/toeic/exams/${exam_id}/finish`

      self.$store.dispatch('isLoading', true)

      const makeRequest = () => {
        api.post(path, { part: part })
          .then(response => {
            self.$store.dispatch('isLoading', false)

            if (isGuideLink) {
              self.$router.push({ name: 'gept_report_part', params: { select_id: self.$route.params.select_id, record_id: response.data.record_id } })
            }

            let recordArray = {
              'conversation_id': self.$route.params.select_id,
              'sentence_sn': response.data.record_id,
              'book': 'GEPT ' + self.$store.state.level,
              'subject': self.unit,
              'unit': self.unitTitle,
              'used_points': self.deduction_points()
            }
            self.$store.dispatch('writeRecord', recordArray)

            self.$nextTick(() => {
              self.ai_sid ? self.$store.dispatch('saveRecord', recordArray) : null
            })
          })
          .catch(() => {
            attempt ++
            if (attempt < maxRetries) {
              setTimeout(makeRequest, retryInterval)
            }
          })
      }

      makeRequest()
    },

    finish_exams_writing (exam_id, part, isGuideLink, seconds) {
      let self = this
      let attempt = 0
      let maxRetries = 10
      let retryInterval  = 10000
      let path = `/toeic/exams/${exam_id}/finish`

      self.$store.dispatch('isLoading', true)

      const makeRequest = () => {
        api.post(path, { part: part })
          .then(response => {
            self.$store.dispatch('isLoading', false)

            if (isGuideLink) {
              let path = `/GEPT/report/${self.$route.params.select_id}/${response.data.record_id}`
              self.$router.push({ path: path })
            }

            let recordArray = {
              'conversation_id': self.$route.params.select_id,
              'sentence_sn': response.data.record_id,
              'book': 'GEPT ' + self.$store.state.level,
              'subject': self.unit,
              'unit': self.unitTitle,
              'used_points': self.deduction_points(),
              'seconds': seconds
            }
            self.$store.dispatch('writeRecord', recordArray)

            self.$nextTick(() => {
              self.ai_sid ? self.$store.dispatch('saveRecord', recordArray) : null
            })
          })
          .catch(() => {
            attempt ++
            if (attempt < maxRetries) {
              setTimeout(makeRequest, retryInterval)
            }
          })
      }

      makeRequest()
    },

    deduction_points () {
      const pointsMap = {
        初級: {
          單句練習: 30,
          段落寫作: 20,
          朗讀句子與短文: 10,
          複誦: 10,
          回答問題: 20
        },
        中級: {
          中譯英: 30,
          英文作文: 30,
          朗讀短文: 20,
          回答問題: 30,
          看圖敘述: 30
        }
      }

      return pointsMap[this.level]?.[this.unit] ?? 10
    }
  }
}

export default All
